<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {defineProps} from "vue";

const props = defineProps({
    authView: {
        type: Boolean,
        default: false
    }
});

const portalContentAndDesignStore =  usePortalContentAndDesignStore()
</script>

<template>
    <radio-group-inline-color
        label="Background color"
        name="portal_layout_background_color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_background_color"
        @picked="portalContentAndDesignStore.portalLayoutSettings.portal_layout_background_color = $event.finalValue"
        :options="[
            { value: 'white', label: 'bg-white', label_is_class: true},
            { value: 'gray-50', label: 'bg-gray-50', label_is_class: true},
            { value: 'gray-100', label: 'bg-gray-100', label_is_class: true},
            { value: 'gray-200', label: 'bg-gray-200', label_is_class: true},
            { value: 'gray-300', label: 'bg-gray-300', label_is_class: true},
            { value: 'custom', label: 'Custom', custom: { name: 'portal_layout_background_color', placeholder: '', type: 'input' }},
        ]"
    >
    </radio-group-inline-color>

    <radio-group-inline-color
        label="Text color"
        name="portal_layout_text_color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_text_color"
        @picked="portalContentAndDesignStore.portalLayoutSettings.portal_layout_text_color = $event.finalValue"
        :options="[
            { value: 'gray-900', label: 'bg-gray-900', label_is_class: true},
            { value: 'gray-800', label: 'bg-gray-800', label_is_class: true},
            { value: 'gray-700', label: 'bg-gray-700', label_is_class: true},
            { value: 'gray-600', label: 'bg-gray-600', label_is_class: true},
            { value: 'gray-500', label: 'bg-gray-500', label_is_class: true},
            { value: 'custom', label: 'Custom', custom: { name: 'portal_layout_text_color', placeholder: '', type: 'input' }},
        ]"
    >
    </radio-group-inline-color>

    <template v-if="!portalContentAndDesignStore.portalLayoutSettings.portal_layout_brand_primary_color_as_partner_and_pages_primary">
        <radio-group-inline-color
            label="Link color"
            name="portal_layout_link_color"
            :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_link_color"
            @picked="portalContentAndDesignStore.portalLayoutSettings.portal_layout_link_color = $event.finalValue"
            :options="[
                { value: 'indigo-700', label: 'bg-indigo-700', label_is_class: true},
                { value: 'blue-700', label: 'bg-blue-700', label_is_class: true},
                { value: 'cyan-700', label: 'bg-cyan-700', label_is_class: true},
                { value: 'teal-600', label: 'bg-teal-600', label_is_class: true},
                { value: 'gray-900', label: 'bg-gray-900', label_is_class: true},
                { value: 'custom', label: 'Custom', custom: { name: 'portal_layout_link_color', placeholder: '', type: 'input' }},
            ]"
        >
        </radio-group-inline-color>

        <radio-group-inline-color
            label="Button color"
            name="portal_layout_button_color"
            :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_button_color"
            @picked="portalContentAndDesignStore.portalLayoutSettings.portal_layout_button_color = $event.finalValue"
            :options="[
                { value: 'indigo-700', label: 'bg-indigo-700', label_is_class: true},
                { value: 'blue-700', label: 'bg-blue-700', label_is_class: true},
                { value: 'cyan-700', label: 'bg-cyan-700', label_is_class: true},
                { value: 'teal-600', label: 'bg-teal-600', label_is_class: true},
                { value: 'black', label: 'bg-black', label_is_class: true},
                { value: 'custom', label: 'Custom', custom: { name: 'portal_layout_button_color', placeholder: '', type: 'input' }},
            ]"
        >
        </radio-group-inline-color>
    </template>
</template>
